import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202605",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 8445,
  clicks: 155,
  adsSpendDollars: 668,
  budgetDollars: 700,
  salesDollars: 2552,
  bestEstimateRoas: 3.82,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.95,
  reorderConversions: 7,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
